import { render } from "./CardStyle.vue?vue&type=template&id=5b91b4a3"
import script from "./CardStyle.vue?vue&type=script&lang=ts"
export * from "./CardStyle.vue?vue&type=script&lang=ts"
script.render = render

export default script